import { Component } from '@angular/core';
import { App, NavController, NavParams, ModalController, PopoverController, Events, FabContainer, LoadingController, AlertController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { PedidosPage } from '../pedidos/pedidos';
import { FacturasPage } from '../facturas/facturas';
import { MonedaPage } from '../moneda/moneda';
import moment from 'moment'

/**
 * Generated class for the VendedoresPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-vendedores',
  templateUrl: 'vendedores.html',
})
export class VendedoresPage {
  vendedores: any = []
  aux: any = []
  resBusq: any = []
  btnCli: any = "A"
  busqueda: any = ''
  skip = 0
  fin = 9
  moneda: any = 'USD'
  loadModal: any 
  fechaAct: any
  actSearch = false
  cargando = false
  successs = false
  errorr = false
  constructor(
    public navCtrl: NavController, 
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    public app: App,
    public alertCtrl: AlertController,
    public popCtrl: PopoverController,
    public events : Events,
    public http: HttpProvider,
    public modalSrv: ModalController
    ) {
      events.subscribe('moneda:update', ()=>{
        this.updateMoneda()
      })
      if(window.localStorage.moneda){
        this.moneda = window.localStorage.moneda
      }
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  initialize() {
    let ven = JSON.parse(localStorage.getItem('vendedoresM'))
    if (ven && ven.length > 0) {
      this.skip = 0
      this.fin = 10
      this.aux = JSON.parse(window.localStorage.getItem('vendedoresM'))
      if (this.btnCli === "M") {
        this.vendedores = this.aux.filter(el=>{
          return el.deuda > 0
        }).slice(this.skip, this.fin)
      } else {
        this.vendedores = this.aux.filter(el=>{
          return el.deuda < 1
        }).slice(this.skip, this.fin)
      }
      this.skip += 10
      this.fin += 10
      this.getVendedores2()
    } else {
      this.getVendedores()
    }
  }

  ionViewDidLoad() {
    this.initialize()
  }

  getVendedores2(){
    this.fechaAct = window.localStorage.getItem('horaVendedor')
    if(window.localStorage.getItem('network') === '1') {
      this.cargando = true
      this.successs = false
      this.errorr = false
      this.http.get(`vendedor/sup?vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
        (res: any) => {
          this.aux = res
          if (!this.actSearch) {
            if (this.btnCli === "M") {
              this.vendedores = this.aux.filter(el=>{
                return el.deuda > 0
              }).slice(0, this.fin)
            } else {
              this.vendedores = this.aux.filter(el=>{
                return el.deuda < 1
              }).slice(0, this.fin)
            }
          }
          window.localStorage.setItem('vendedoresM', JSON.stringify(res))
          window.localStorage.setItem('horaVendedor', moment().format('DD-MM-YYYY H:mm A'));
          this.fechaAct = window.localStorage.getItem('horaVendedor')
          this.cargando = false
          this.successs = true
        }, 
        err => {
          this.errorr = true
          this.cargando = false
          console.log(err)
        }
      )
    } else {
      this.errorr = true
      this.cargando = false
      // this.alertCtrl.create({
      //   title: 'Atención',
      //   subTitle:'No se encuentra conexión con ninguna red.',
      //   buttons:[
      //     {
      //       text:'Aceptar',
      //       cssClass:'btnAceptar',
      //       handler:()=>{
      //       }
      //     }
      //   ]
      // }).present()
    }
  }

  // verVendedor(ven){
  //   this.navCtrl.push(VendedorPage,ven.co_ven)
  // }

  reset(){
    if(this.busqueda.length < 1) {
      this.resBusq = []
      this.actSearch = false
      if (this.btnCli === "A") {
        this.vendedores = this.aux.filter(el=>{
          return el.deuda < 1
        }).slice(0, 9)
      } else {
        this.vendedores = this.aux.filter(el=>{
          return el.deuda > 0
        }).slice(0, 9)
      }
      this.skip = 10
      this.fin = 19
    }
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  showMonedas(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  buscar(){
    this.resBusq = []
    this.resBusq = this.aux.filter((el) => {
      let arry = this.busqueda.split(' ')
      if (arry.length === 1) {
        return el.co_ven.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1 ||
          el.ven_des.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1
      } else {
        let cont = 0
        let cont2 = 0
        for (let i = 0; i < arry.length; i++) {
          if (el.co_ven.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont++
          }
          if (el.ven_des.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont2++
          }
          el.puntuacion = (cont > cont2) ? cont : cont2
        }
        if (cont > 0 || cont2 > 0) {
          return el
        }
      }
    })
    this.resBusq.sort(function(a, b) {
      return b.puntuacion - a.puntuacion;
    });
    this.skip=0
    this.fin=9
    this.vendedores = this.resBusq.slice(this.skip, this.fin)
    this.skip+=10
    this.fin+=10
    this.actSearch = true
    // if (this.btnCli === "A") {
    //   this.vendedores = res.filter(el=>{
    //     return el.deuda < 1
    //   })
    // } else {
    //   this.vendedores = res.filter(el=>{
    //     return el.deuda > 0
    //   })
    // }
  }

  irPedidos(ven, fab: FabContainer){
    fab.close()
    this.navCtrl.push(PedidosPage,{vendedor: ven.co_ven})
  }

  irFacturas(ven, fab: FabContainer, vend){
    fab.close()
    this.navCtrl.push(FacturasPage,{ obj : { tipo: 'ven', cod: ven, moroso: (vend.deuda > 0) ? true : false } })
  }

  doInfinite(infiniteScroll){
    // this.vendedores = this.vendedores.concat(this.aux.slice(this.skip, this.fin))
    if (!this.actSearch) {
      if (this.btnCli === "A") {
        this.vendedores = this.vendedores.concat(this.aux.filter(el=>{
          return el.deuda < 1
        }).slice(this.skip, this.fin))
      } else {
        this.vendedores = this.vendedores.concat(this.aux.filter(el=>{
          return el.deuda > 0
        }).slice(this.skip, this.fin))
      }
    } else {
      this.vendedores = this.vendedores.concat(this.resBusq.slice(this.skip, this.fin))
    }
    this.skip += 10
    this.fin += 10
    infiniteScroll.complete()
  }

  changeData(item) {
    this.btnCli = item
    this.skip = 0
    this.fin = 9
    if (item === "A") {
      this.vendedores = this.aux.filter(el=>{
        return el.deuda < 1
      }).slice(this.skip, this.fin)
    } else {
      this.vendedores = this.aux.filter(el=>{
        return el.deuda > 0
      }).slice(this.skip, this.fin)
    }
    this.skip += 10
    this.fin += 10
  }

  getVendedores(){
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.cargando = true
      this.successs = false
      this.errorr = false
      this.http.get(`vendedor/sup?vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
        (res: any) => {
          this.DesactivarLoading()
          this.aux = res
          this.vendedores = this.aux.filter(el=>{
            return el.deuda < 1
          }).slice(this.skip, this.fin)
          // this.vendedores = this.aux.slice(this.skip, this.fin)
          this.skip += 10
          this.fin += 10
          window.localStorage.setItem('vendedoresM', JSON.stringify(res))
          window.localStorage.setItem('horaVendedor', moment().format('DD-MM-YYYY H:mm A'));
          this.fechaAct = window.localStorage.getItem('horaVendedor')
          this.cargando = false
          this.successs = true
        }, 
        err => {
          this.errorr = true
          this.cargando = false
          this.DesactivarLoading()
          console.log(err)
        }
      )
    } else {
      this.errorr = true
      this.cargando = false
      // this.alertCtrl.create({
      //   title: 'Atención',
      //   subTitle:'No se encuentra conexión con ninguna red.',
      //   buttons:[
      //     {
      //       text:'Aceptar',
      //       cssClass:'btnAceptar',
      //       handler:()=>{
      //       }
      //     }
      //   ]
      // }).present()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/vendedores/vendedores.ts